import delay from 'lodash-es/delay'
import { ThunkDispatch } from './actions/creators/baseHelpers'
import { withBase } from './utils/appBase'

let currentRevision: string | null = null
const waitTime = 30 * 1000
export let appNeedsRefresh = false

export const checkRevision = (dispatch: ThunkDispatch) => {
  fetch(withBase('/revision'), { credentials: 'include' }).then(
    (res) => {
      res.text().then((revision) => {
        if (currentRevision && currentRevision !== revision) {
          appNeedsRefresh = true
        }
        currentRevision = revision
        delay(() => {
          checkRevision(dispatch)
        }, waitTime)
      })
    },
    () => {
      console.error('Could not load revision, frontend-backend down?')
      delay(() => {
        checkRevision(dispatch)
      }, waitTime)
    }
  )
}
